/**
 * rarityLabels.ts — hoe we een zeldzaamheidsniveau van een Djay-look benoemen.
 *
 * WAAROM DIT ÉÉN BRON IS
 *
 * Er stonden twee onafhankelijke labeltabellen: één in `CollectionPage` (de kast)
 * en één in `SkinEvolutionReveal` (de onthulling). Ze weken af op het tweede
 * niveau: **"Ongewoon"** in de kast, **"Bijzonder"** in de onthulling — voor
 * hetzelfde niveau van dezelfde look.
 *
 * Dat is verwarrender dan het lijkt. Een kind ziet de onthulling en daarna de
 * kast, binnen een minuut, en moet zelf concluderen dat twee woorden hetzelfde
 * betekenen. Een verzameling werkt alleen als de niveaus een vaste naam hebben;
 * dat is de hele reden dat je erop spaart.
 *
 * "Bijzonder" is gekozen boven "Ongewoon". Het is warmer en voor een kind van
 * tien direct te begrijpen, terwijl "ongewoon" vooral "niet gewoon" zegt — een
 * ontkenning, geen beloning.
 *
 * WAT HIER NIET IN HOORT
 *
 * Alleen de woorden. De kast tekent met Tailwind-klassen, de onthulling met
 * hex-stralen; die twee zijn niet uitwisselbaar en horen bij hun eigen
 * weergave. De naam is het besluit dat gedeeld is.
 */

import type { MascotRarity } from './useVariantUnlocks';

/** Het woord dat een kind ziet voor elk zeldzaamheidsniveau. */
export const RARITY_LABELS: Record<MascotRarity, string> = {
  common: 'Gewoon',
  uncommon: 'Bijzonder',
  rare: 'Zeldzaam',
  legendary: 'Legendarisch',
  secret: 'Geheim'
};
